import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { contentTypesKeys } from './queryKeyFactory';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { MainDocContentTypeResponse } from '../../Model/responseDtos/MainDocContentTypeResponse';

export function useGetContentType(
  ctName?: string,
  locale?: string
): UseQueryResult<MainDocContentTypeResponse, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getContentType = () => {
    if (servicesCtx?.contentTypesService && ctName) {
      return servicesCtx.contentTypesService.getContentType(ctName, locale);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: contentTypesKeys.byCtName(ctName, locale),
    queryFn: getContentType,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!ctName
  });
}
